import React from 'react'
import DashboardLayout from '../layout'
import Header from '../header/Header'
import IorCalculatorForm from './IorCalculatorForm'
import { useQuery } from "@tanstack/react-query";
import { getSettings } from "../../lib/setting";

const IorCalculatorPage = () => {
    // Fetch settings data using the same pattern as AddressFormadmin
    const { data: settingsData, isLoading: settingsLoading } = useQuery(
        ["settings"],
        getSettings,
        {
            refetchOnWindowFocus: false,
        }
    );

    return (
        <DashboardLayout>
            <div className="w-full border border-red">
                <Header title="One Union TradeOS™" />
                <div className="min-h-[100vh] w-full flex items-center justify-center">
                    <div className="w-full h-full max-w-[80vw]">
                        {/* Pass settingsData and loading state to IorCalculatorForm */}
                        <IorCalculatorForm
                            settingsData={settingsData}
                            settingsLoading={settingsLoading}
                        />
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default IorCalculatorPage